module.exports = __webpack_public_path__ + "img/www.imdb.com.dd4dd2b6.png";